export default __webpack_public_path__ + "locales/lo-LA/HotkeysPanel.json?hash=f975d7caaa552839b023fa0619ab5553";